import { render } from 'base/wrapped-render-v2';
import { createRoot } from 'react-dom/client';
import { CompanyData } from './company-data.react';
import { Modals as ModalConstants } from './constants';

const rootElement = document.createElement('div');
document.body.appendChild(rootElement);
const root = createRoot(rootElement);

export function renderCompanyData(props) {
	render({
		children: <CompanyData { ...props } />,
		root,
	});
}

export const Modals = ModalConstants;

export const clearDemoData = () => {
	renderCompanyData({
		defaultModal: ModalConstants.CLEAR_DEMO_DATA_MODAL,
		onDefaultModalClose: () => renderCompanyData({ defaultModal: undefined }),
	});
};